

if (!customElements.get('custom-slideshow')) {
  class CustomSlideShow extends HTMLElement {
    constructor() {
      super();


    }
    connectedCallback(){
 
      this.slideshow()
    }

    slideshow(){
  
      const slides = this.querySelectorAll('.carousel__slide');
      if (!slides.length) return;
      let prev_button = this.querySelector('.flickity-prev'),
      next_button = this.querySelector('.flickity-next'),
      progress_bar = this.parentNode?.querySelector('.flickity-progress--bar');
       if(Array.from(slides).length == 1){
    prev_button.classList.add("is-hidden");
     next_button.classList.add("is-hidden")
  }


      const args = {
        wrapAround: true,
        cellAlign: 'center',
        pageDots: false,
        lazyLoad: true,
        imagesLoaded: true,
        prevNextButtons: false,
        autoPlay: false,
        cellSelector: '.carousel__slide',
        on: {}
      };

      // ✅ Progress bar (copied safely from slide-show)
      if (progress_bar) {
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          const total = this.slides.length;
          const current = this.selectedIndex + 1;
          progress_bar.style.width = `${(current / total) * 100}%`;
        };
      }

      this.flkty = new Flickity(this, args);
      this.dataset.initiated = true;
   

this.flkty.on('ready', () => this.handleVideos());
      this.flkty.on('change', () => this.handleVideos());

setTimeout(() => {
  this.flkty.resize();
}, 100);
 

            if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev_button.addEventListener('keyup', (event) => {
          this.flkty.previous();
        });
        next_button.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next_button.addEventListener('keyup', (event) => {
          this.flkty.next();
        });
      }
    }

handleVideos() {
  if (!this.flkty) return;

  // Pause all videos
  this.querySelectorAll('video').forEach(video => {
    video.pause();
    video.currentTime = 0;
  });

  // Play active slide video
  const activeSlide = this.flkty.selectedElement;
  if (!activeSlide) return;

  const video = activeSlide.querySelector('video');
  if (video) {
    video.muted = true;           // required
    video.playsInline = true;     // important for iOS
    video.autoplay = true;        // ensure autoplay
    video.play().catch(() => {});
  }
}

  }

  customElements.define('custom-slideshow', CustomSlideShow);
}
